import React from 'react';
import { ErrorBoundedProvider } from 'reactifi-local';
import { Router, Route, hashHistory } from 'react-router';
import createStore from './store/attendeeStore';
import AttendeeContainer from './containers/AttendeeContainer';
import { syncHistoryWithStore } from 'react-router-redux';

export default (props, _railsContext) => {
  const store = createStore(props);
  const history = syncHistoryWithStore(hashHistory, store);
  const reactComponent = (
    <ErrorBoundedProvider store={store}>
      <Router history={history}>
        <Route
          path="/"
          component={AttendeeContainer}
          accountId={props.accountId}
          isEventManagement={props.isEventManagement}
        />
      </Router>
    </ErrorBoundedProvider>
  );
  return reactComponent;
};
